export default __webpack_public_path__ + "static/media/JUMPILOTLOGO.6e00de80.png";